module.exports = __webpack_public_path__ + "static/media/despacho_verde.26c94b1f.svg";